import { Component, Vue } from 'vue-property-decorator';

@Component
export default class GetUsingTypeMixin extends Vue {
  getUsingType({ type} :{type:string}) {
    switch(type) {
      case 'campaign':
        return this.t('Campaign');

      case 'offer':
        return this.t('Offer');

      case 'flow':
        return  this.t('Flow');

      case 'landing':
        return this.t('Landing');

      case 'trafficSource':
        return this.t('Traffic Source');

      case 'affiliateNetwork':
        return this.t('Affiliate Network');

      case 'trackingDomain':
        return this.t('Tracking domain');

      default:
        return '';
    }
  }
}